var _path, _path2, _linearGradient, _path3, _linearGradient2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Template(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M42,8H6c-1.1,0-2,0.9-2,2v28c0,1.1,0.9,2,2,2h36c1.1,0,2-0.9,2-2V10C44,8.9,43.1,8,42,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M40,12v4c0,0.6-0.5,1-1.1,1H9.1C8.5,17,8,16.6,8,16v-4c0-0.6,0.5-1,1.1-1h29.9C39.5,11,40,11.4,40,12z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 8,
    x2: 22,
    y1: 28.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M22,35.3V21.7c0-0.9-0.7-1.7-1.6-1.7H9.6C8.7,20,8,20.8,8,21.7v13.6C8,36.2,8.7,37,9.6,37h10.9 C21.3,37,22,36.2,22,35.3z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 26,
    x2: 40,
    y1: 28.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M40,35.3V21.7c0-0.9-0.7-1.7-1.6-1.7H27.6c-0.9,0-1.6,0.8-1.6,1.7v13.6c0,0.9,0.7,1.7,1.6,1.7h10.9 C39.3,37,40,36.2,40,35.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Template);
export default __webpack_public_path__ + "static/media/icons8-template.0a5dabd3f26a8fb19518b98727a6cdb8.svg";
export { ForwardRef as ReactComponent };